// /mnt/mantenimientos/frontend/src/components/GestionTab.jsx
import React, { useMemo, useState } from "react";
import CredencialesTab from "./CredencialesTab";
import { actualizarOrdenador, actualizarOrdenadorSpecs } from "../api";
import "./gestionTab.css";

function toNullIfEmpty(v) {
  const s = String(v ?? "").trim();
  return s ? s : null;
}

function toIntOrNull(v) {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  if (!s) return null;
  const n = Number(s);
  if (!Number.isFinite(n)) return null;
  return Math.trunc(n);
}

export default function GestionTab({
  subTab,
  setSubTab,
  clienteEdit = { nombre: "", telefono: "", observaciones: "", codigo_cliente: "", email: "",
    direccion: "", es_cliente_mantenimiento: true },
  setClienteEdit,
  guardarCliente,
  eliminarCliente,
  ordenadores = [],
  nuevoOrdenador,
  setNuevoOrdenador,
  crearOrdenador,
  eliminarOrdenador,
  guardarOrdenador,
  mostrarFormOrdenador,
  setMostrarFormOrdenador,
  clienteId,
  clienteNombre,
  refrescarOrdenadores,
}) {
  const [editId, setEditId] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState("");
  const [credentialsOpen, setCredentialsOpen] = useState(false);

  // ✅ editForm incluye HW
  const [editForm, setEditForm] = useState({
    descripcion: "",
    hostname: "",
    ip: "",
    so: "",
    usuario: "",
    teamviewer_id: "",
    info_adicional: "",

    serial: "",
    cpu: "",
    ram_gb: "",
    disco_gb: "",
    ssd: false,
  });

  const startEdit = (o) => {
    setEditError("");
    setEditId(o.id);

    setEditForm({
      descripcion: o.descripcion || "",
      hostname: o.hostname || "",
      ip: o.ip || "",
      so: o.so || "",
      usuario: o.usuario || "",
      teamviewer_id: o.teamviewer_id || "",
      info_adicional: o.info_adicional || "",

      serial: o.serial || "",
      cpu: o.cpu || "",
      ram_gb: o.ram_gb ?? "",
      disco_gb: o.disco_gb ?? "",
      ssd: !!o.ssd,
    });
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditError("");
    setEditLoading(false);
    setEditForm({
      descripcion: "",
      hostname: "",
      ip: "",
      so: "",
      usuario: "",
      teamviewer_id: "",
      info_adicional: "",

      serial: "",
      cpu: "",
      ram_gb: "",
      disco_gb: "",
      ssd: false,
    });
  };

  const saveEdit = async () => {
    if (!editId) return;

    const nombre = String(editForm.descripcion || "").trim();
    if (!nombre) {
      setEditError("La descripción / nombre del equipo es obligatoria.");
      return;
    }

    setEditLoading(true);
    setEditError("");

    try {
      // 1) specs (incluye usuario + HW)
      await actualizarOrdenadorSpecs(editId, {
        hostname: toNullIfEmpty(editForm.hostname),
        ip: toNullIfEmpty(editForm.ip),
        so: toNullIfEmpty(editForm.so),
        usuario: toNullIfEmpty(editForm.usuario),

        serial: toNullIfEmpty(editForm.serial),
        cpu: toNullIfEmpty(editForm.cpu),
        ram_gb: toIntOrNull(editForm.ram_gb),
        disco_gb: toIntOrNull(editForm.disco_gb),
        ssd: !!editForm.ssd,
      });

      // 2) base
      const payloadBase = {
        descripcion: nombre,
        teamviewer_id: toNullIfEmpty(editForm.teamviewer_id),
        info_adicional: toNullIfEmpty(editForm.info_adicional),
      };

      try {
        await actualizarOrdenador(editId, payloadBase);
      } catch (e) {
        // fallback (si lo tienes)
        if (guardarOrdenador) {
          await guardarOrdenador(editId, payloadBase);
        } else {
          throw e;
        }
      }

      // 3) refrescar lista
      if (typeof refrescarOrdenadores === "function") {
        await refrescarOrdenadores();
      }

      cancelEdit();
    } catch (e) {
      setEditError(e?.response?.data?.error || e.message || "Error guardando equipo");
    } finally {
      setEditLoading(false);
    }
  };

  const ordenadoresSorted = useMemo(
    () => [...ordenadores].sort((a, b) => String(a.descripcion || "").localeCompare(String(b.descripcion || ""))),
    [ordenadores]
  );

  return (
    <div className="gtWrap">
      <div className="gtTop">
        <div className="clients-tabs gtTabs">
          <button
            className={`pill ${subTab === "detalles" ? "pill-ok" : "pill-neutral"}`}
            onClick={() => setSubTab("detalles")}
            type="button"
          >
            📝 Detalles
          </button>

          <button
            className={`pill ${subTab === "ordenadores" ? "pill-ok" : "pill-neutral"}`}
            onClick={() => setSubTab("ordenadores")}
            type="button"
          >
            💻 Equipos
          </button>

          <button
            className={`pill ${subTab === "credenciales" ? "pill-ok" : "pill-neutral"}`}
            onClick={() => setSubTab("credenciales")}
            type="button"
          >
            🔑 Credenciales
          </button>
        </div>

        {subTab === "detalles" && (
          <div className="gtActions">
            <button className="btn" type="button" onClick={guardarCliente} title="Guardar cambios del cliente">
              💾 Guardar
            </button>
            <button className="btn gtBtnDanger" type="button" onClick={eliminarCliente} title="Eliminar cliente">
              🗑️ Eliminar
            </button>
          </div>
        )}
      </div>

      <div className="gtBody">
        {subTab === "detalles" && (
          <div className="gtSection">
            <div className="gtGrid">
              <div className="gtField">
                <label>Código de Cliente</label>
                <input
                  type="text"
                  className="input"
                  value={clienteEdit.codigo_cliente}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, codigo_cliente: e.target.value })}
                />
              </div>

              <div className="gtField">
                <label>Nombre</label>
                <input
                  type="text"
                  className="input"
                  value={clienteEdit.nombre}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, nombre: e.target.value })}
                />
              </div>

              <div className="gtField">
                <label>Teléfono</label>
                <input
                  type="text"
                  className="input"
                  value={clienteEdit.telefono}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, telefono: e.target.value })}
                />
              </div>

              <div className="gtField">
                <label>Email</label>
                <input
                  type="email"
                  className="input"
                  value={clienteEdit.email}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, email: e.target.value })}
                />
              </div>

              <div className="gtField gtFieldFull">
                <label>Dirección</label>
                <input
                  type="text"
                  className="input"
                  value={clienteEdit.direccion || ""}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, direccion: e.target.value })}
                  placeholder="Calle, número, localidad y código postal"
                />
              </div>

              <div className="gtField gtFieldFull">
                <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <input
                    type="checkbox"
                    checked={clienteEdit.es_cliente_mantenimiento !== false && Number(clienteEdit.es_cliente_mantenimiento) !== 0}
                    onChange={(e) => setClienteEdit({ ...clienteEdit, es_cliente_mantenimiento: e.target.checked })}
                  />
                  Cliente de mantenimiento
                </label>
                <small>Solo los clientes marcados aparecen en los módulos operativos.</small>
              </div>

              {/* ✅ Observaciones (simple, sin expandir) */}
              <div className="gtField gtFieldFull">
                <label>Observaciones</label>
                <textarea
                  className="textarea"
                  value={clienteEdit.observaciones}
                  onChange={(e) => setClienteEdit({ ...clienteEdit, observaciones: e.target.value })}
                  placeholder="Notas internas, horarios, particularidades…"
                />
              </div>
            </div>
          </div>
        )}

        {subTab === "ordenadores" && (
          <div className="gtSection">
            <div className="gtSectionHead">
              <div>
                <div className="gtH">Equipos</div>
                <div className="gtSub">{ordenadoresSorted.length} registrados</div>
              </div>

              <button className="btn" type="button" onClick={() => setMostrarFormOrdenador(!mostrarFormOrdenador)}>
                {mostrarFormOrdenador ? "— Cerrar" : "➕ Añadir equipo"}
              </button>
            </div>

            {/* Crear equipo */}
            {mostrarFormOrdenador && (
              <div className="gtCard">
                <div className="gtGrid" style={{ marginTop: 0 }}>
                  <div className="gtField gtFieldFull">
                    <label>Descripción (Nombre del equipo)</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="Ej: PC Recepción, Servidor, NAS…"
                      value={nuevoOrdenador?.descripcion || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), descripcion: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>Host</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="HOSTNAME"
                      value={nuevoOrdenador?.hostname || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), hostname: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>IP</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="192.168.1.10"
                      value={nuevoOrdenador?.ip || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), ip: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>SO</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="Windows 10 / Server 2022 / Synology…"
                      value={nuevoOrdenador?.so || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), so: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>Usuario</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="usuario / admin"
                      value={nuevoOrdenador?.usuario || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), usuario: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>ID TeamViewer (opcional)</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="Ej: 123456789"
                      value={nuevoOrdenador?.teamviewer_id || ""}
                      onChange={(e) =>
                        setNuevoOrdenador((prev) => ({ ...(prev || {}), teamviewer_id: e.target.value }))
                      }
                    />
                  </div>

                  {/* HW */}
                  <div className="gtField">
                    <label>Serial (opcional)</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="Nº de serie"
                      value={nuevoOrdenador?.serial || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), serial: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>CPU (opcional)</label>
                    <input
                      type="text"
                      className="input"
                      placeholder="i5-10400 / Ryzen 5…"
                      value={nuevoOrdenador?.cpu || ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), cpu: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>RAM (GB)</label>
                    <input
                      type="number"
                      className="input"
                      placeholder="16"
                      value={nuevoOrdenador?.ram_gb ?? ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), ram_gb: e.target.value }))}
                    />
                  </div>

                  <div className="gtField">
                    <label>Disco (GB)</label>
                    <input
                      type="number"
                      className="input"
                      placeholder="512"
                      value={nuevoOrdenador?.disco_gb ?? ""}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), disco_gb: e.target.value }))}
                    />
                  </div>

                  <div className="gtField" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <input
                      id="gtSSDCreate"
                      type="checkbox"
                      checked={!!nuevoOrdenador?.ssd}
                      onChange={(e) => setNuevoOrdenador((prev) => ({ ...(prev || {}), ssd: e.target.checked }))}
                    />
                    <label htmlFor="gtSSDCreate" style={{ margin: 0 }}>
                      SSD
                    </label>
                  </div>

                  <div className="gtField gtFieldFull">
                    <label>Info adicional</label>
                    <textarea
                      className="textarea"
                      rows={3}
                      placeholder="Notas del equipo, ubicación, particularidades…"
                      value={nuevoOrdenador?.info_adicional || ""}
                      onChange={(e) =>
                        setNuevoOrdenador((prev) => ({ ...(prev || {}), info_adicional: e.target.value }))
                      }
                    />
                  </div>

                  <div className="gtInlineActions">
                    <button className="btn" type="button" onClick={crearOrdenador}>
                      ✅ Crear equipo
                    </button>
                  </div>
                </div>
              </div>
            )}

            {ordenadoresSorted.length === 0 ? (
              <div className="gtEmpty">No hay equipos.</div>
            ) : (
              <div className="gtList">
                {ordenadoresSorted.map((o) => {
                  const isEditing = editId === o.id;

                  return (
                    <div key={o.id} className="gtCard">
                      <div className="gtCardHead">
                        <div className="gtCardTitle">💻 {o.descripcion || `Equipo #${o.id}`}</div>

                        {!isEditing ? (
                          <div className="gtInlineActions">
                            <button className="btn" type="button" onClick={() => startEdit(o)}>
                              ✏️ Editar
                            </button>
                            {typeof eliminarOrdenador === "function" ? (
                              <button className="btn gtBtnDanger" type="button" onClick={() => eliminarOrdenador(o.id)}>
                                🗑️ Eliminar
                              </button>
                            ) : null}
                          </div>
                        ) : null}
                      </div>

                      {!isEditing ? (
                        <div className="gtMeta">
                          <div>
                            🖥 Host: <strong>{o.hostname || "—"}</strong>
                          </div>
                          <div>
                            🌐 IP: <strong>{o.ip || "—"}</strong>
                          </div>
                          <div>
                            💿 SO: <strong>{o.so || "—"}</strong>
                          </div>
                          <div>
                            👤 Usuario: <strong>{o.usuario || "—"}</strong>
                          </div>
                          <div>
                            🔢 Serial: <strong>{o.serial || "—"}</strong>
                          </div>
                          <div>
                            🧠 CPU: <strong>{o.cpu || "—"}</strong>
                          </div>
                          <div>
                            🧰 RAM: <strong>{o.ram_gb ?? "—"} GB</strong>
                          </div>
                          <div>
                            💽 Disco: <strong>{o.disco_gb ?? "—"} GB</strong> {o.ssd ? "(SSD)" : ""}
                          </div>
                          <div>
                            🖧 TeamViewer: <strong>{o.teamviewer_id || "—"}</strong>
                          </div>
                          <div>ℹ️ {o.info_adicional || "Sin info adicional"}</div>
                        </div>
                      ) : (
                        <>
                          {editError ? <div className="gtEmpty" style={{ color: "#b42318" }}>{editError}</div> : null}

                          <div className="gtGrid">
                            <div className="gtField gtFieldFull">
                              <label>Descripción (Nombre del equipo)</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.descripcion}
                                onChange={(e) => setEditForm((p) => ({ ...p, descripcion: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>Host</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.hostname}
                                onChange={(e) => setEditForm((p) => ({ ...p, hostname: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>IP</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.ip}
                                onChange={(e) => setEditForm((p) => ({ ...p, ip: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>SO</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.so}
                                onChange={(e) => setEditForm((p) => ({ ...p, so: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>Usuario</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.usuario}
                                onChange={(e) => setEditForm((p) => ({ ...p, usuario: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>ID TeamViewer</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.teamviewer_id}
                                onChange={(e) => setEditForm((p) => ({ ...p, teamviewer_id: e.target.value }))}
                              />
                            </div>

                            {/* HW edit */}
                            <div className="gtField">
                              <label>Serial</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.serial}
                                onChange={(e) => setEditForm((p) => ({ ...p, serial: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>CPU</label>
                              <input
                                type="text"
                                className="input"
                                value={editForm.cpu}
                                onChange={(e) => setEditForm((p) => ({ ...p, cpu: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>RAM (GB)</label>
                              <input
                                type="number"
                                className="input"
                                value={editForm.ram_gb}
                                onChange={(e) => setEditForm((p) => ({ ...p, ram_gb: e.target.value }))}
                              />
                            </div>

                            <div className="gtField">
                              <label>Disco (GB)</label>
                              <input
                                type="number"
                                className="input"
                                value={editForm.disco_gb}
                                onChange={(e) => setEditForm((p) => ({ ...p, disco_gb: e.target.value }))}
                              />
                            </div>

                            <div className="gtField" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <input
                                id={`gtSSD-${editId}`}
                                type="checkbox"
                                checked={!!editForm.ssd}
                                onChange={(e) => setEditForm((p) => ({ ...p, ssd: e.target.checked }))}
                              />
                              <label htmlFor={`gtSSD-${editId}`} style={{ margin: 0 }}>
                                SSD
                              </label>
                            </div>

                            <div className="gtField gtFieldFull">
                              <label>Info adicional</label>
                              <textarea
                                className="textarea"
                                rows={3}
                                value={editForm.info_adicional}
                                onChange={(e) => setEditForm((p) => ({ ...p, info_adicional: e.target.value }))}
                              />
                            </div>

                            <div className="gtInlineActions">
                              <button className="btn" type="button" onClick={saveEdit} disabled={editLoading}>
                                {editLoading ? "Guardando…" : "💾 Guardar"}
                              </button>
                              <button className="btn" type="button" onClick={cancelEdit} disabled={editLoading}>
                                ✖ Cancelar
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {subTab === "credenciales" && (
          <div className="gtSection">
            <section className="gtCredentialsLaunch">
              <div>
                <span className="pill pill-neutral">Inventario central</span>
                <h3>Credenciales del cliente</h3>
                <p>Consulta accesos globales y por equipo en una sola vista, con búsqueda, filtros y revelado temporal.</p>
              </div>
              <button className="button primary" type="button" onClick={() => setCredentialsOpen(true)}>
                Abrir inventario de credenciales
              </button>
            </section>
          </div>
        )}
      </div>

      {credentialsOpen ? (
        <div className="modal-overlay gtCredentialsOverlay" onMouseDown={(event) => event.target === event.currentTarget && setCredentialsOpen(false)}>
          <div className="modal gtCredentialsModal" role="dialog" aria-modal="true" aria-label="Inventario de credenciales">
            <div className="modal-header gtCredentialsModalHead">
              <div><h3>Credenciales</h3><p>{clienteNombre || clienteEdit?.nombre || "Cliente"}</p></div>
              <button className="button secondary small" type="button" onClick={() => setCredentialsOpen(false)}>Cerrar</button>
            </div>
            <div className="modal-body gtCredentialsModalBody">
              <CredencialesTab embedded clienteId={clienteId} clienteNombre={clienteNombre || clienteEdit?.nombre} ordenadores={ordenadoresSorted} />
            </div>
            <div className="modal-footer"><button className="button secondary" type="button" onClick={() => setCredentialsOpen(false)}>Cerrar</button></div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
